import { StatusColumnType } from '@shared/components/data-list/common';

export const PRINT_TABLE = {
  HEAD: `
    <head>
        <style>
            body { font-family: Arial; }
            @page { size: auto; margin-top: 15px; }
            @media print {
                .cipo-table {
                    -webkit-print-color-adjust: exact;
                    border-collapse: collapse;
                    width: 100%;
                    font: 12px Arial;
                    th {
                        padding: 8px 4px;
                        text-transform: uppercase; 
                        background-color: #edf3f9; 
                        border-bottom: 2px solid #ddd;
                        font-size: 11px;
                    }

                    td {
                        padding: 4px 8px;
                        border-bottom: 1px solid #ddd;

                        .state-container {
                            padding: 4px 8px;
                            border-radius: 4px;
                            display: inline-block;
                            text-transform: uppercase;
                            text-align: center;
                            width: 90%;
                        }
                    }
                }
            }
            .page-header {
                margin-bottom: 15px;
                border-bottom: 2px solid #bbb;
                width: 100%;
                font-size: 11px;

                h3 { margin: 15px 0; }
            }
            .text-center { text-align: center; }
            .text-right { text-align: right; }
        </style>
    </head>`,
  getStateElement: (state: StatusColumnType) => `
            <p class="state-container" style="background-color: ${state.bgColor}; color: ${state.color};">
                ${state.label}
            </p>
        `,
  getImageThumb: (src: string) => `<img src="${src}" style="max-width: 50px;" />`,
} as const;
